export enum LineOfBusiness {
  ACA = "ACA",
  Medicare = "Medicare",
  Life = "Life",
  Supplementary = "Supplementary",
}
